/**
 * Refund Channel Values for select in History Refund
 * @type {{DOMISERVE: string, CRCESU: string}}
 */
export const RefundTrackSelectValues = {
    DOMISERVE: "DOMISERVE",
    CRCESU: "CRCESU",
}
